module.exports = __webpack_public_path__ + "static/media/tablet-rugged.37580392.svg";